var env = process.env.NODE_ENV || 'dev';

if(env == 'prod') {
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    
    gtag('config', 'UA-140381151-1');
}
